(() => {
  const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  initHero(prefersReduced);
  initSafeDemo(prefersReduced);
  initLayers(prefersReduced);
  initCert(prefersReduced);
  initSteps(prefersReduced);
  initBanner(prefersReduced);
  initCopyTag();
})();

function initHero(prefersReduced) {
  const reveals = document.querySelectorAll(".reveal");
  if (!reveals.length) return;

  if (prefersReduced || typeof gsap === "undefined") {
    reveals.forEach((el) => {
      el.style.opacity = "1";
      el.style.transform = "none";
    });
    return;
  }

  const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

  tl.fromTo(
    ".hero__media",
    { scale: 1.06, opacity: 0.7 },
    { scale: 1, opacity: 1, duration: 1.35, ease: "power2.out" },
    0
  );

  tl.to(
    reveals,
    {
      opacity: 1,
      y: 0,
      duration: 0.75,
      stagger: 0.12,
    },
    0.2
  );
}

function initSafeDemo(prefersReduced) {
  const root = document.querySelector("[data-safe-demo]");
  const pinDesktop = document.querySelector("[data-safe-pin]");
  if (!root || typeof gsap === "undefined") return;

  const sleeve = root.querySelector(".safe-demo__sleeve");
  const base = root.querySelector(".safe-demo__base");
  const orient = root.querySelector(".safe-demo__orient");
  const steps = [...root.querySelectorAll(".safe-steps__item")];

  if (!sleeve || !base || !orient) return;

  let activeStep = -1;
  let finaleTl = null;

  const setStep = (index) => {
    if (index === activeStep) return;
    activeStep = index;
    steps.forEach((step, i) => {
      step.classList.toggle("is-active", i === index);
    });
  };

  const killFinale = () => {
    if (finaleTl) {
      finaleTl.kill();
      finaleTl = null;
    }
  };

  const playFinale = () => {
    if (finaleTl && finaleTl.isActive()) return;

    killFinale();
    finaleTl = gsap.timeline({
      onComplete: () => {
        finaleTl = null;
      },
    });

    finaleTl.to({}, { duration: 0.55 });
    finaleTl.call(() => setStep(2));
    finaleTl.to({}, { duration: 0.7 });
    finaleTl.call(() => setStep(3));
  };

  const seatedX = () => orient.clientWidth * 0.05;
  const offX = () => Math.min(orient.clientWidth * 0.72, sleeve.offsetWidth * 0.92);

  const arm = () => {
    if (prefersReduced) {
      gsap.set(sleeve, {
        x: seatedX(),
        y: 0,
        yPercent: -50,
        xPercent: -50,
        autoAlpha: 1,
        scale: 1,
        rotation: 0,
      });
      setStep(3);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    gsap.set(sleeve, {
      x: offX(),
      y: 0,
      yPercent: -50,
      xPercent: -50,
      autoAlpha: 1,
      scale: 1.015,
      rotation: 0.6,
      transformOrigin: "20% 50%",
    });
    setStep(0);

    const mm = gsap.matchMedia();

    const buildScroll = (pinTarget, start) => {
      let wasComplete = false;

      const tl = gsap.timeline({
        defaults: { ease: "none" },
        scrollTrigger: {
          trigger: pinTarget,
          start,
          end: () => `+=${Math.round(window.innerHeight * 0.85)}`,
          pin: true,
          scrub: 0.65,
          anticipatePin: 1,
          invalidateOnRefresh: true,
          onUpdate: (self) => {
            const done = self.progress >= 0.995;

            if (done) {
              if (!wasComplete) {
                wasComplete = true;
                setStep(1);
                playFinale();
              }
              return;
            }

            if (wasComplete) {
              wasComplete = false;
              killFinale();
            }

            setStep(self.progress < 0.72 ? 0 : 1);
          },
        },
      });

      // Надень — файл наезжает на основу
      tl.to(sleeve, {
        x: () => seatedX(),
        scale: 1,
        rotation: 0,
        duration: 0.78,
        ease: "power2.inOut",
      });

      // мягкая посадка
      tl.to(sleeve, {
        x: () => seatedX() - 3,
        duration: 0.08,
        ease: "power1.out",
      });
      tl.to(sleeve, {
        x: () => seatedX(),
        duration: 0.14,
        ease: "power2.out",
      });

      return () => {
        killFinale();
        wasComplete = false;
        tl.scrollTrigger?.kill();
        tl.kill();
        gsap.set(sleeve, {
          x: offX(),
          scale: 1.015,
          rotation: 0.6,
        });
        setStep(0);
      };
    };

    const pinTarget = pinDesktop || root;

    // Desktop + mobile: pin header + demo together
    mm.add("(min-width: 769px)", () => buildScroll(pinTarget, "center center"));
    mm.add("(max-width: 768px)", () => buildScroll(pinTarget, "top top"));
  };

  const images = [base, sleeve];
  let pending = images.filter((img) => !img.complete).length;

  if (!pending) {
    arm();
    return;
  }

  images.forEach((img) => {
    if (img.complete) return;
    img.addEventListener(
      "load",
      () => {
        pending -= 1;
        if (pending === 0) {
          arm();
          ScrollTrigger.refresh();
        }
      },
      { once: true }
    );
  });
}

function initLayers(prefersReduced) {
  const root = document.querySelector("[data-layers]");
  if (!root || typeof gsap === "undefined") return;

  const copy = root.querySelectorAll(".layers__title, .layers__lead, .layers__cta");
  const img = root.querySelector(".layers__img");
  const callouts = [...root.querySelectorAll(".layers-callout")];

  if (!img || !callouts.length) return;

  const lines = callouts.map((el) => el.querySelector(".layers-callout__line"));
  const labels = callouts.map((el) => el.querySelector(".layers-callout__label"));

  if (prefersReduced) {
    gsap.set([copy, img, lines, labels], {
      autoAlpha: 1,
      x: 0,
      y: 0,
      scaleY: 1,
      rotate: 0,
    });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  gsap.set(copy, { autoAlpha: 0, y: 24 });
  // Тяжёлый металлический въезд: без rotate/overshoot, резкая остановка
  gsap.set(img, { autoAlpha: 0, x: 160, force3D: true });

  callouts.forEach((callout, i) => {
    const origin = callout.dataset.origin === "top" ? "50% 0%" : "50% 100%";
    gsap.set(lines[i], {
      scaleY: 0,
      transformOrigin: origin,
      autoAlpha: 1,
    });
    gsap.set(labels[i], {
      autoAlpha: 0,
      y: callout.dataset.origin === "top" ? 10 : -10,
    });
  });

  const tl = gsap.timeline({
    defaults: { ease: "power3.out" },
    scrollTrigger: {
      trigger: root,
      start: "top 65%",
      once: true,
    },
  });

  tl.to(copy, {
    autoAlpha: 1,
    y: 0,
    duration: 0.7,
    stagger: 0.1,
  });

  tl.to(
    img,
    {
      autoAlpha: 1,
      x: 0,
      duration: 0.85,
      ease: "expo.out",
    },
    "-=0.25"
  );

  tl.to(
    lines,
    {
      scaleY: 1,
      duration: 0.55,
      stagger: 0.12,
      ease: "power2.out",
    },
    "-=0.25"
  );

  tl.to(
    labels,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.45,
      stagger: 0.12,
      ease: "power2.out",
      clearProps: "transform",
    },
    "-=0.45"
  );
}

function initCert(prefersReduced) {
  const root = document.querySelector("[data-cert]");
  if (!root || typeof gsap === "undefined") return;

  const header = root.querySelectorAll(".cert__title, .cert__lead");
  const img = root.querySelector(".cert__img");
  const points = root.querySelectorAll(".cert-point");
  const cta = root.querySelector(".cert__cta");

  if (prefersReduced) {
    gsap.set([header, img, points, cta], { autoAlpha: 1, x: 0, y: 0 });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  gsap.set(header, { autoAlpha: 0, y: 28 });
  gsap.set(img, { autoAlpha: 0, y: 24 });
  gsap.set(points, { autoAlpha: 0, y: 24 });
  gsap.set(cta, { autoAlpha: 0, y: 16 });

  const tl = gsap.timeline({
    defaults: { ease: "power3.out" },
    scrollTrigger: {
      trigger: root,
      start: "top 70%",
      once: true,
    },
  });

  tl.to(header, {
    autoAlpha: 1,
    y: 0,
    duration: 0.7,
    stagger: 0.1,
  });

  tl.to(
    img,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.9,
      ease: "power3.out",
      clearProps: "transform",
    },
    "-=0.35"
  );

  tl.to(
    points,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.55,
      stagger: 0.12,
    },
    "-=0.55"
  );

  tl.to(
    cta,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.5,
    },
    "-=0.25"
  );
}

function initSteps(prefersReduced) {
  const root = document.querySelector("[data-steps]");
  if (!root || typeof gsap === "undefined") return;

  const title = root.querySelector(".steps__title");
  const items = root.querySelectorAll(".steps__item");

  if (prefersReduced) {
    gsap.set([title, items], { autoAlpha: 1, y: 0 });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  gsap.set(title, { autoAlpha: 0, y: 24 });
  gsap.set(items, { autoAlpha: 0, y: 36 });

  const tl = gsap.timeline({
    defaults: { ease: "power3.out" },
    scrollTrigger: {
      trigger: root,
      start: "top 72%",
      once: true,
    },
  });

  tl.to(title, {
    autoAlpha: 1,
    y: 0,
    duration: 0.65,
  });

  tl.to(
    items,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.6,
      stagger: 0.12,
    },
    "-=0.25"
  );
}

function initCopyTag() {
  const tags = document.querySelectorAll("[data-copy-tag]");
  if (!tags.length) return;

  tags.forEach((tag) => {
    const value = tag.textContent.trim();
    let resetTimer = null;

    tag.addEventListener("click", async () => {
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(value);
        } else {
          const input = document.createElement("textarea");
          input.value = value;
          input.setAttribute("readonly", "");
          input.style.position = "fixed";
          input.style.opacity = "0";
          document.body.appendChild(input);
          input.select();
          document.execCommand("copy");
          document.body.removeChild(input);
        }

        const wrap = document.querySelector(".safefiling-wrapper");
        const copiedLabel = wrap?.dataset.copied || "Copied";
        const copyAria = wrap?.dataset.copyAria || "Copy hashtag";

        clearTimeout(resetTimer);
        tag.classList.add("is-copied");
        tag.setAttribute("aria-label", copiedLabel);
        tag.textContent = copiedLabel;

        resetTimer = setTimeout(() => {
          tag.classList.remove("is-copied");
          tag.textContent = value;
          tag.setAttribute("aria-label", `${copyAria} ${value}`);
        }, 1600);
      } catch {
        // clipboard may be blocked — leave label unchanged
      }
    });
  });
}

function initBanner(prefersReduced) {
  const root = document.querySelector("[data-banner]");
  if (!root || typeof gsap === "undefined") return;

  const media = root.querySelector(".banner__media");
  const parts = root.querySelectorAll(
    ".banner__title, .banner__lead, .banner__actions"
  );

  if (prefersReduced) {
    gsap.set([media, parts], { autoAlpha: 1, x: 0, y: 0, scale: 1 });
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  gsap.set(media, { scale: 1.04, autoAlpha: 0.85 });
  gsap.set(parts, { autoAlpha: 0, y: 28 });

  const tl = gsap.timeline({
    defaults: { ease: "power3.out" },
    scrollTrigger: {
      trigger: root,
      start: "top 70%",
      once: true,
    },
  });

  tl.to(media, {
    scale: 1,
    autoAlpha: 1,
    duration: 1.1,
    ease: "power2.out",
  });

  tl.to(
    parts,
    {
      autoAlpha: 1,
      y: 0,
      duration: 0.7,
      stagger: 0.12,
    },
    "-=0.7"
  );
}
